/**
 * @Page REPD0
 * @Description [REPD0]수신자료관리 - ERP_자재정보조회 - 품목정보(D0)
 **/
import React, { useState, useEffect, useRef, useCallback, forwardRef } from "react";
import Ribbon from '@/components/organisms/Ribbon';
import ContentXearch from '@/components/organisms/ContentXearch';
import Content from '@/components/organisms/Content';
import Grid from '@/components/grid/agGrid';
import CustomAlert from "@/components/molecules/CustomAlert";
import AlertDialog from '@/components/material-UI/AlertDialog';
import * as Common from '@/utils/Common'; // Common.js
import CommonUtil from '@/utils/CommonUtil'; // Util.js
import { getToday } from "@/utils/Common";
import UploadModal from "@/components/organisms/UploadModal";
import Loading from "src/components/atoms/CustomLoading2";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER;
const CODES = require('@/config/commonCode.json');
const Utils = new CommonUtil();



function REPD0() {
    const token = Common.getToken();
    const userId = Common.getToken("id");
    const tVnt1 = Common.getToken("vand");
    const tComp = Common.getToken("comp");
    const bigi = Common.getToken("bigi");
    const grdRepd0Main = useRef();   // Grid Main
    const ckVnt1 = Common.getCookie("ck_vnt1" + userId) === null || Common.getCookie("ck_vnt1" + userId) === "" || Common.getCookie("ck_vnt1" + userId) === "undefined" ? tVnt1 : Common.getCookie("ck_vnt1" + userId);
    let [loading, setLoading] = useState(false);

    //Data
    const [idata, setData] = useState({
        kFpdt: getToday(),
        kTpdt: getToday(),
        kDocd: "",
        // kVnt1 : tVnt1,      //T1업체
        kVnt1: ckVnt1,        //T1업체     
        //kVdnm:"",           //업체명
        kComp: tComp,       //회사구분
        kPtno: "",
        kVnt1Nm: "",        //T1업체명
        kCompNm: tComp === "EHMC" ? "현대자동차(주)" : "기아자동차(주)",        //회사명
        kPageNum: 1,//하단 페이지
        kPageTotal: 0,//total 페이지
        kTotcnt: 0,//total 갯수

        //코드 데이터
        vnt1List: [],  //T1업체 
        plntList: [],  //공장
        gubnList: [],  //하치장
        compList: [],  //회사구분
        docdList: [],  //문서코드
    });


    const [message, setMessage] = React.useState({
        openAlert: false,
        severity: "success",
        msg: ""
    });
    const { openAlert, severity, msg } = message;
    const [uploadInfo, setUploadInfo] = useState({ vnt1: tVnt1, subDir: "DATA" });

    //Dialog
    const [dlgMessage, setDlgMessage] = React.useState({
        openDlg: false,
        dlgTrans: "",      // Dialog Transaction(I,U,D)
        dlgMsg: ""
    });
    const { openDlg, dlgTrans, dlgMsg } = dlgMessage;

    let [searchApi, setSearchApi] = useState(false);
    const [openUpload, setOpenUpload] = React.useState(false); // Modal 항목 setting

    const [panded, setPanded] = React.useState(true);
    const [style, setStyle] = useState({ height: "calc(100vh - 65px - 35px - 50px - 21px - 56px - 8px )" });

    const [gridApi, setGridApi] = useState(null);

    const onClearApi = useCallback(async (e) => {
        setSearchApi(false);
    }, []);

    const onGridReady = (params) => {
        setGridApi(params);
        // 그리드가 준비되면 0.1초 뒤에 레이아웃을 다시 계산하도록 강제 명령
        setTimeout(() => {
            params.api.sizeColumnsToFit();
        }, 100);
    };
    /**
     * 공통코드 fetch 헬퍼 (Promise 반환)
     */
    const fetchCommon = (para) => {
        const param = encodeURI(para);
        const query = SERVER_URL + "/comcd/search?query=" + param;
        return fetch(query, { headers: { Authorization: token } }).then((resp) => resp.json());
    };

    /**
     * MOUNT - 공통코드 병렬 조회 후 setData 1회 호출
     */
    useEffect(() => {
        const loadInitialData = async () => {
            try {
                const [vnt1Res, compRes, docdRes, vnt1NmRes] = await Promise.all([
                    fetchCommon(`{"pgmid":"VNT1"}`),
                    fetchCommon(`{"pgmid":"COMP"}`),
                    fetchCommon(`{"pgmid":"DOC_ERPD0","kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}"}`),
                    fetchCommon(`{"pgmid":"WRCVAND","kVnt1":"${idata.kVnt1}"}`),
                ]);

                setData((prev) => ({
                    ...prev,
                    vnt1List: vnt1Res.success ? vnt1Res.data : prev.vnt1List,
                    compList: compRes.success ? compRes.data : prev.compList,
                    docdList: docdRes.success ? docdRes.data : prev.docdList,
                    kVnt1Nm: vnt1NmRes.success && vnt1NmRes.data.length > 0
                        ? vnt1NmRes.data[0].text
                        : prev.kVnt1Nm,
                }));
            } catch (e) {
                console.error("초기 공통코드 조회 실패", e);
            }
        };

        loadInitialData();
        window.dispatchEvent(new Event('resize'));
    }, []);



    /**
     * Control 변경 Event
     * @param {*} e
     */
    const onChange = async (e) => {
        const { name, value, desc } = e.target;

        let newSearchs = idata;
        let newUploadInfo = uploadInfo;
        newSearchs[name] = value
        setData({ ...newSearchs });


        //T1업체, 회사구분 변경시 
        if (name === "kVnt1") {
            newSearchs["kDocd"] = "";
            newSearchs["kPageNum"] = 1;
            newUploadInfo["vnt1"] = value;
            newSearchs[name + "Nm"] = desc;
            setData({ ...newSearchs });
            setUploadInfo({ ...newUploadInfo });

        }
        if (name === "kComp") {
            newSearchs[name + "Nm"] = desc;
            newSearchs["kDocd"] = "";
            setData({ ...newSearchs });

            // 회사구분 변경 시 문서코드 재조회
            fetchCommon(`{"pgmid":"DOC_ERPD0","kVnt1":"${idata.kVnt1}","kComp":"${value}"}`)
                .then((res) => {
                    if (res.success) {
                        setData((prev) => ({ ...prev, docdList: res.data }));
                    }
                })
                .catch((e) => console.error("docdList 조회 실패", e));
        }
        if (name === "kDocd") {
            newSearchs["kPageNum"] = 1;
            setData({ ...newSearchs });
        }
    }


    /**
     * 검색조건
     */
    const optionsX = {
        0: [
            // T1업체
            {
                formatter: "select", name: "kVnt1", labelName: "1차업체", type: "text", defaultValue: idata.kVnt1,
                codeMode: true,
                selectAll: "", // selectAll :: 전체 option 표출 여부 :: { "comCode" : "" , "text" : "전체" }
                codes: null,
                comms: idata.vnt1List,
                align: "left",
            },
            // 회사구분
            {
                formatter: "select", name: "kComp", labelName: "회사구분", type: "text", defaultValue: idata.kComp,
                codeMode: false,
                selectAll: "", // selectAll :: 전체 option 표출 여부 :: { "comCode" : "" , "text" : "전체" }
                codes: CODES["comp"],
                comms: null,
                align: "left",
            },
            // 문서코드
            {
                formatter: "select", name: "kDocd", labelName: "문서코드", type: "text", defaultValue: idata.kDocd,
                codeMode: false,
                selectAll: false, // selectAll :: 전체 option 표출 여부 :: { "comCode" : "" , "text" : "전체" }
                codes: [{ comCode: "", text: "문서 전체" }],
                comms: idata.docdList,
                align: "left",
            },
            // 품번
            {
                formatter: "input", name: "kPtno", labelName: "품번", type: "text", defaultValue: idata.kPtno,
                codeMode: false,
                selectAll: "", // selectAll :: 전체 option 표출 여부 :: { "comCode" : "" , "text" : "전체" }
                codes: null, // 2015~2022년까지 :: Case 1 - codes :: Code List
                comms: null,
                align: "left",
            },
            // 전체건수
            {
                formatter: "input", name: "KTotcnt", labelName: "전체건수", type: "text", defaultValue: idata.kTotcnt,
                codeMode: false,
                selectAll: "", // selectAll :: 전체 option 표출 여부 :: { "comCode" : "" , "text" : "전체" }
                codes: null, // 2015~2022년까지 :: Case 1 - codes :: Code List
                comms: null,
                align: "left",
            },
            { "formatter": "blank", "align": "right" }
        ],
    }

    //조회건수
    const onSetCount = (e) => {
        let cnt;
        if (gridApi.api.rowRenderer.gridApi.rowModel.rowsToDisplay.length > 0) {
            cnt = gridApi.api.rowRenderer.gridApi.rowModel.rowsToDisplay[0].data.cnt;
        } else {
            cnt = 0;
        }
        let newSearchs = idata;

        if (idata.kPageNum === 1) {
            newSearchs["kPageTotal"] = Math.ceil(parseInt(cnt) / 500);
            newSearchs["kTotcnt"] = Common.getNumberFormatter(cnt);
            setData({ ...newSearchs });
        }
    }

    /**
     * 조회
     * @param {*} e
     * @returns
     */
    const onSearch = async (e) => {

        // Cookie 값 셋팅
        Common.setCookie("ck_vnt1" + userId, idata.kVnt1, 1);


        const page = "ERPD0"
        let para = `{
                        "kGubn":"${page}",
                        "kVnt1": "${idata.kVnt1}", "docd": "${idata.kDocd}", "kComp": "${idata.kComp}","kPtno":"${idata.kPtno}",
                        "kPageNum":"${idata.kPageNum}"
                    }`;
        let param = encodeURI(para);

        const query = SERVER_URL + "/repd/search?query=" + param;
        setSearchApi(query); // Search API

    }

    /**
      * 파일생성
      * @param {*} e 
      */
    const onUpload = async (e) => {
        let newSearchs = idata;

        newSearchs["vnt1"] = idata.kWrcVand;
        setData({ ...newSearchs });

        setOpenUpload(true);
    }

    const handleUploadClickOpen = () => {
        setOpenUpload(true);
    };

    const handleUploadClose = () => {
        setOpenUpload(false);
    };


    /**
     * 신규 Row추가
     * @param {*} e
     */
    const onAddRow = async (e) => {
    }



    /**
     * 입력 (발행)
     * @param {*} e
     */
    const onInsert = async (e) => {

    }



    /**
     * 수정
     * @param {*} e
     * @returns
     */
    const onUpdate = async (e) => {
    }

    /**
     * 삭제
     * @param {*} e
     */
    const onDelete = async (e) => {
    }


    /**
     * 엑셀
     * @param {*} e 
     */
    const onExcel = async (e) => {
        const page = "ERPD0"
        let para = `{"kDocument":"D0 품목정보","kGubn":"${page}","kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}","kDocd":"${idata.kDocd}",
                     "vnt1Nm":"${idata.kVnt1Nm}","compNm":"${idata.kCompNm}","docdNm":"${idata.kDocd === "" ? "전체" : idata.kDocd}","kTotcnt": "${idata.kTotcnt}"}`;

        let param = encodeURIComponent(para);
        const query = SERVER_URL + "/repd/excel?query=" + param;

        //엑셀파일 조회 시 로딩오픈
        setLoading(true);

        await fetch(query, { headers: { Authorization: token } })
            .then((resp) => {
                return resp.blob();
            }).then((blob) => {
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', 'ERPD0.xls');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                return Promise.reject({ Error: 'error', err });
            })

        setLoading(false);

        // 엑셀파일 생성 메세지
        setMessage({
            openAlert: true,
            severity: "success",
            msg: "엑셀파일이 생성되었습니다."
        });
    }

    //Transaction AlertDialogResult
    const AlertDialogResult = async (e) => {

        //AlertDialog 초기화
        setDlgMessage({ openDlg: false, dlgTrans: "", dlgMsg: "" });



        //DialogResult
        if (e.result == "N") return;

        //Transaction 구분
        switch (e.Trans) {
            //등록
            case "I":
                break;
            //수정
            case "U":
                break;
            //삭제
            case "D2":
                break;
            case "D3":
                break;
        }
    }

    const onPrevnClickedEvent = (params) => {

        let newSearchs = idata;

        if (idata.kPageNum != 1) {
            newSearchs["kPageNum"] = idata.kPageNum - 1;
        } else {
            newSearchs["kPageNum"] = 1;
        }

        setData({ ...newSearchs });

        if (idata.kPageNum >= 1) {
            onSearch();
        }
    }

    const onNextClickedEvent = (params) => {
        let newSearchs = idata;

        newSearchs["kPageNum"] = idata.kPageNum + 1;
        setData({ ...newSearchs });

        if (idata.kPageTotal >= idata.kPageNum) {
            onSearch();
        }
    }
    /**
     *Grid Column 정의
     */
    // 월별 컬럼
    const mainColumnDefs = [
        { headerName: "Document Code", field: "COL01", sortable: true, filter: true, flex: 1, minWidth: 150, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "공장", field: "COL03", sortable: true, filter: true, flex: 1, minWidth: 80, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "품번", field: "COL04", sortable: true, filter: true, flex: 1, minWidth: 130, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignL"], singleClickEdit: true, valueGetter: Utils.partnoGetter, hide: false },
        { headerName: "효력시작일", field: "COL05", sortable: true, filter: true, flex: 1, minWidth: 110, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, valueFormatter: Utils.dateFormatter, hide: false },
        { headerName: "효력종료일", field: "COL06", sortable: true, filter: true, flex: 1, minWidth: 110, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, valueFormatter: Utils.dateFormatter, hide: false },
        { headerName: "품명", field: "COL07", sortable: true, filter: true, flex: 1, minWidth: 180, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignL"], singleClickEdit: true, hide: false },
        { headerName: "단위", field: "COL08", sortable: true, filter: true, flex: 1, minWidth: 80, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "하치장 번호", field: "COL09", sortable: true, filter: true, flex: 1, minWidth: 110, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "차종", field: "COL10", sortable: true, filter: true, flex: 1, minWidth: 90, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "납입 Box No", field: "COL11", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "용기당 수량", field: "COL12", sortable: true, filter: true, flex: 1, minWidth: 110, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "Location No", field: "COL13", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "담당자", field: "COL14", sortable: true, filter: true, flex: 1, minWidth: 80, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "1회용기수", field: "COL15", sortable: true, filter: true, flex: 1, minWidth: 100, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "검수 유/무", field: "COL16", sortable: true, filter: true, flex: 1, minWidth: 100, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "발주형태", field: "COL17", sortable: true, filter: true, flex: 1, minWidth: 90, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "실적구분", field: "COL18", sortable: true, filter: true, flex: 1, minWidth: 90, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "발행구분", field: "COL19", sortable: true, filter: true, flex: 1, minWidth: 90, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "물류대행 구분", field: "COL20", sortable: true, filter: true, flex: 1, minWidth: 130, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "입고방식 구분", field: "COL21", sortable: true, filter: true, flex: 1, minWidth: 130, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "서열비 정산 구분", field: "COL22", sortable: true, filter: true, flex: 1, minWidth: 130, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "구매문서 번호", field: "COL23", sortable: true, filter: true, flex: 1, minWidth: 130, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "구매문서 품목 번호", field: "COL24", sortable: true, filter: true, flex: 1, minWidth: 150, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false }
    ];

    const onClick = async (e) => {
        setPanded(!panded);

        if (panded === true) {
            setStyle({
                height: "calc(100vh - 65px - 35px - 50px - 21px - 8px)"
            });
        } else {
            setStyle({
                height: "calc(100vh - 65px - 35px - 50px - 21px - 56px - 8px)"
            });
        }
    }

    return (
        <>
            {/* Dialog FRAME */}
            <AlertDialog open={openDlg} trans={dlgTrans} message={dlgMsg} onClose={AlertDialogResult} />

            {/* Alert FRAME */}
            <CustomAlert open={openAlert} severity={severity} duration={3000} message={msg} onClose={() => { setMessage({ ...message, openAlert: false }) }} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />

            {/* Loading */}
            <Loading loading={loading} />

            {/* Ribbon Frame : 프로그램 Path 및 버튼 */}
            <Ribbon
                onSearch={onSearch} onSearchName={null}     //조회
                onUpload={onUpload} onUploadName={"생성"}//생성   
                onExcel={onExcel} onExcelName={null}   //Excel
            >
                {"수신자료관리 > 자재정보자료조회 > "}<b style={{ color: "#cd5c5c", fontFamily: "PretendardLight, NanumGothic, sans-serif" }}>품목정보 [ D0 ]</b>
            </Ribbon>

            {/* Upload FRAME */}
            <UploadModal
                open={openUpload}
                onClose={handleUploadClose}
                onClickOpen={handleUploadClickOpen}
                title={"CSV 업로드"}
                fileId={"ERPD0"}
                filePath={"C:\\HKC\\VAN\\ERPD0.CSV"}
                uploadInfo={uploadInfo}
                accp=".csv"
                maxFiles={1}
                validatorName={"csv"}
                uploadApi={SERVER_URL + "/erp/upload1"}
                data={idata.vnt1List}
            />

            <ContentXearch
                optionsX={optionsX}
                onChange={onChange}
                onClick={onClick} />

            {/* Content FRAME (Data / Grid Frame) START -------------- */}
            <Content style={style}> {/* Content 항목에서의 100%에서 Header:60px,  Ribbon:50px,  검색조건:55px */}
                <div className={"grid_type01"}> {/* 상단 FRAME */}
                    <div className={"grid_wrap01"}> {/* 상단 wrap FRAME */}
                        <div className="grid_cont_box" style={{ height: "calc(100%)" }}>
                            <Grid
                                ref={grdRepd0Main}
                                gridId={"REPD0"}                    //  (필수) Grid Id 정의
                                columnDefs={mainColumnDefs}             //  (필수) 컬럼 정의
                                pagination={true}                  //  쪽수 매기기 여부
                                paginationCsv={false}                //  CSV 사용구분 - pagination과 동시에 사용 필요
                                onGridReadyEvent={onGridReady}
                                paginationPageSize={"1000"}         //  쪽수 1Page 당 Row수
                                rowMultiSelectWithClick={true}      //  멀티 클릭 가능 여부
                                suppressRowClickSelection={true}   //  클릭으로 선택 하는것을 방지
                                rowSelection={"multiple"}           //  여러개 선택 "multiple" 가능, 한개 선택할 때는 "single"
                                enableRangeSelection={false}        //
                                enableCellTextSelection={true}      // cell selection drag mode
                                isFirst={false}                     // 첫번째 컬럼 체크박스 사용여부 - ( default 체크박스 사용안함 )
                                displayNo={false}
                                searchApi={searchApi}               // 조회
                                onClearApi={() => { onSetCount(); onClearApi() }}
                                onRowClickEvent={null}
                                // paginationCustom = {true}
                                onPrevnClickedEvent={onPrevnClickedEvent}
                                onNextClickedEvent={onNextClickedEvent}
                            />
                        </div>
                    </div>
                </div>
            </Content>
        </>
    )
}
export default REPD0;